import ProfileCard from "widgets/cards/profile";
import EditUserForm, { UserEditFormType } from "widgets/forms/users/edit";
import { useTranslation } from "react-i18next";

// Define the props for the Role component
interface RoleProps {
  role?: string;
  onSubmit?: (formData: UserEditFormType) => void;
}

const Role: React.FC<RoleProps> = ({ role = "", onSubmit }) => {
  const { t } = useTranslation();
  const handleSubmit = (formData: UserEditFormType) => {
    if (onSubmit) {
      onSubmit(formData);
    }
  };
  return (
    <>
      <ProfileCard
        title={t("dialog.user.role.title")}
        description={t("dialog.user.role.description")}
        bgColor="bg-background-100"
        textColor="text-white"
        textDescriptionColor="text-white"
        extra="h-full"
      >
        <EditUserForm
          values={{ role: role }}
          submit={handleSubmit}
          onClose={() => {}}
        />
      </ProfileCard>
    </>
  );
};

export default Role;
